import {
  FETCH_ORDERSFROMCHEMIST_SUCCESS_ACTION,
  FETCH_NORMALPROCESSEDORDERS_SUCCESS_ACTION,
  FETCH_DELIVEREDNORMALORDERS_SUCCESS_ACTION,
  FETCH_URGENT_ORDERS_SUCCESS_ACTION,
  FETCH_PROCESSEDURGENTORDERS_SUCCESS_ACTION,
  FETCH_DELIVEREDURGENTORDERS_SUCCESS_ACTION,
  FETCH_RETURNS_SUCCESS_ACTION,
  FETCH_CREDITNOTES_SUCCESS_ACTION,
  FETCH_SUPPORTTICKETS_SUCCESS_ACTION,
  FETCH_CANCELNORMALORDERS_SUCCESS_ACTION,
  FETCH_CANCELURGENTORDERS_SUCCESS_ACTION,
} from "./action";

const initialState = {
  processing: false,
  error: false
};

export default function(state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_ORDERSFROMCHEMIST_SUCCESS_ACTION:
      return {
        ...state,
        newnormalOrdersListCount: action.payload.count
      };

    case FETCH_NORMALPROCESSEDORDERS_SUCCESS_ACTION:
      return {
        ...state,
        processednormalOrdersListCount: action.payload.count
      };

    case FETCH_DELIVEREDNORMALORDERS_SUCCESS_ACTION:
      return {
        ...state,
        deliverednormalOrdersListCount: action.payload.count
      };

    case FETCH_CANCELNORMALORDERS_SUCCESS_ACTION:
      return {
        ...state,
        cancellnormalOrdersListCount: action.payload.count
      };

    case FETCH_CANCELURGENTORDERS_SUCCESS_ACTION:
      return {
        ...state,
        cancellurgentOrdersListCount: action.payload.count
      };

    case FETCH_URGENT_ORDERS_SUCCESS_ACTION:
      return {
        ...state,
        urgentOrders: action.payload.rows,
        urgentOrdersCount: action.payload.count
      };

    case FETCH_PROCESSEDURGENTORDERS_SUCCESS_ACTION:
      return {
        ...state,
        processedurgentOrdersListCount: action.payload.count
      };

    case FETCH_DELIVEREDURGENTORDERS_SUCCESS_ACTION:
      return {
        ...state,
        deliveredurgentOrdersListCount: action.payload.count
      };

    case FETCH_RETURNS_SUCCESS_ACTION:
      return {
        ...state,
        orderReturnListCount: action.payload.count
      };

    case FETCH_CREDITNOTES_SUCCESS_ACTION:
      return {
        ...state,
        creditNotesCount: action.payload.count
      };

    case FETCH_SUPPORTTICKETS_SUCCESS_ACTION:
      return {
        ...state,
        supportTicketsList: action.payload.rows,
        supportTicketsListCount: action.payload.count
      };

    default:
      return {
        ...state
      };
  }
}
